import React from 'react';
import { Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import { normalizeAttachments } from './contentAttachments';
import './platform-content-attachments.css';

function ContentAttachmentsActions({ item, className = '' }) {
  const attachments = normalizeAttachments(item);

  if (!attachments.length) {
    return null;
  }

  return (
    <div className={`platform-content-attachments ${className}`.trim()}>
      {attachments.map((attachment, index) => (
        <Button
          key={attachment.url}
          variant={index === 0 ? 'primary' : 'outline-primary'}
          href={attachment.url}
          target="_blank"
          rel="noopener noreferrer"
          className="platform-content-attachments__btn"
        >
          <FaDownload aria-hidden="true" />
          {attachments.length === 1 ? 'Prenesi datoteko' : attachment.name}
        </Button>
      ))}
    </div>
  );
}

export default ContentAttachmentsActions;
